import $ from 'jquery';
import 'image-map-resizer';
import SyosEvents from './utils/SyosEvents';
import { templateScreenButtonListItem } from './templates/templates';
import SyosUiContainer from './SyosUiContainer';
import SyosGlobalConfig from './SyosGlobalConfig';
import { Click, GestureList } from './utils/GestureHelper';

const Class = {
  MAP_CONTAINER: 'tn-syos-screen-container__map-container',
  BTN_LIST: 'tn-syos-screen-container__button-list',
  BTN_LIST_CONTAINER: 'tn-syos-screen-container__button-list-container',
  BTN_LIST_CONTAINER_STANDALONE_MODIFIER: 'tn-syos-screen-container__button-list-container--standalone',
};

const html = `
  <div class="${Class.BTN_LIST_CONTAINER}">
    <h3 class="${Class.BTN_LIST}-heading">Select a section</h3>
    <ul class="${Class.BTN_LIST}"></ul>
  </div>
  <div class="${Class.MAP_CONTAINER}" aria-hidden="true"></div>
`;

class SyosScreenContainer extends SyosUiContainer {
  constructor(syosController) {
    super(syosController, '.tn-syos-screen-container');

    this.bindMethods();

    this.$el.html(html);
    this.$mapContainer = this.find(`.${Class.MAP_CONTAINER}`);
    this.$btnList = this.find(`.${Class.BTN_LIST}`);
    this.$btnListContainer = this.find(`.${Class.BTN_LIST_CONTAINER}`);

    this.$mapContainer.hide();
    this.$btnListContainer.hide();

    this.buttonsMap = new Map();

    this.syosController.on(SyosEvents.SCREEN_UPDATED, this.onScreenUpdated);
  }

  bindMethods() {
    this.onScreenUpdated = this.onScreenUpdated.bind(this);
    this.onImageMapAreaMouseOver = this.onImageMapAreaMouseOver.bind(this);
    this.onImageMapAreaMouseOut = this.onImageMapAreaMouseOut.bind(this);
  }

  onScreenUpdated({ screen }) {
    if (screen) {
      this.$el.css({ display: 'none' });
    } else {
      this.show();
    }
  }

  setData(screenData) {
    this.syosController.hideSeatContainer();
    this.draw(screenData);
  }

  selectScreen(screen) {
    if (screen.IsSYOS) {
      if (screen.Available) {
        this.syosController.setCurrentScreen(screen);
      }
    } else {
      const zoneQuery = screen.RedirectUrl || 'z=0';
      document.location.href = `${SyosGlobalConfig.bestAvailableBasePath}?${zoneQuery}`;
    }
  }

  draw(screens) {
    /*
    <script id="smap-4-template" ...
      <img name="smap4" id="smap4" usemap="#m_smap4" src="foo.gif" ...
      <map name="m_smap4" id="m_smap4">
        <area id="smap-4-screen-1a" screenId="syos-id-1" class="smap-4-screen-1" alt="screen-1" ...
        <area id="smap-4-screen-1b" ...
        ...
      </map>
    </script>
    */

    const firstScreen = screens[0];
    const mapNumber = firstScreen.smap_no;
    const screenButtonIsSectionHeadingOnly =
      !firstScreen.screenButtonShouldDisplayPricetypeDescription &&
      !firstScreen.screenButtonShouldRenderPriceRange;

    this.$customScreen = $(`#smap-${mapNumber}-template`); // #smap-4-template

    if (this.getIsUsingCustomBirdsEye()) {
      this.$mapContainer.append(this.$customScreen.html());
    } else {
      this.$btnListContainer.addClass(Class.BTN_LIST_CONTAINER_STANDALONE_MODIFIER);
      this.$mapContainer.remove();
    }

    const clickHandlers = [];

    screens.forEach((screen) => {
      const screenId = screen.screen_no;
      const screenClass = `.smap-${mapNumber}-screen-${screenId}`; // .smap-4-screen-1
      const buttonTemplateData = Object.assign({}, screen, {
        screenButtonIsSectionHeadingOnly,
      });

      const onClick = () => this.selectScreen(screen);

      const $screens = $(screenClass);
      if ($screens.length) {
        // There could be multiple UI elements representing a given screen
        $screens.each((index, screenEl) => {
          const handler = new Click(screenEl, onClick);
          clickHandlers.push(handler);
        });
      }

      const $listItem = $(templateScreenButtonListItem.render(buttonTemplateData));
      const $btn = $listItem.find('button');

      const handler = new Click($btn[0], onClick);
      clickHandlers.push(handler);

      this.gestures = new GestureList(clickHandlers).start();

      this.buttonsMap.set(screenId, $btn);

      this.$btnList.append($listItem);
    });

    const $maps = this.$mapContainer.find('map');
    if ($maps.length) {
      $maps.imageMapResize();

      const $imageMapAreas = $maps.find('area');
      $imageMapAreas.attr('tabindex', 0); // Make areas tabbable
      $imageMapAreas.on('mouseover focus', this.onImageMapAreaMouseOver);
      $imageMapAreas.on('mouseout blur', this.onImageMapAreaMouseOut);

      $imageMapAreas.toArray().forEach((area) => {
        const $area = $(area);
        let screenId = $area.attr('screenid');
        if (screenId !== null) {
          screenId = screenId.replace(/[^\d]/g, '');
          screenId = parseInt(screenId, 10);
          $area.attr('data-tn-screen-id', screenId);
        }
      });
    }

    const screenId = this.syosController.getScreenId();

    if (screenId) {
      const screenToSelect = screens.find(obj => obj.screen_no === screenId);

      if (screenToSelect && screenToSelect.Available) {
        this.selectScreen(screenToSelect);

        return;
      }
    }

    this.show();
  }

  getIsUsingCustomBirdsEye() {
    if (this.$customScreen) {
      return this.$customScreen.length > 0;
    }

    return false;
  }

  getButtonForArea(area) {
    const $area = $(area);
    let screenId = $area.attr('data-tn-screen-id');
    if (screenId) {
      screenId = parseInt(screenId, 10);
      return this.buttonsMap.get(screenId);
    }
    return null;
  }

  onImageMapAreaMouseOver(event) {
    const $button = this.getButtonForArea(event.target);
    if ($button !== null) {
      this.buttonsMap.forEach(($btn) => {
        if ($button === $btn) {
          $btn.addClass('tn-syos-screen-container__button--seat-map-hover-active');
        } else {
          $btn.addClass('tn-syos-screen-container__button--seat-map-hover-inactive');
        }
      });
    }
  }

  onImageMapAreaMouseOut() {
    this.buttonsMap.forEach(($btn) => {
      $btn.removeClass('tn-syos-screen-container__button--seat-map-hover-active tn-syos-screen-container__button--seat-map-hover-inactive');
    });
  }

  show() {
    const $els = this.$mapContainer.add(this.$btnListContainer);
    $els.css({ display: '', opacity: 0 });
    this.$el.css({ display: '' });
    $els.animate({ opacity: 1 });
  }
}

export default SyosScreenContainer;



// WEBPACK FOOTER //
// ./src/syos/SyosScreenContainer.js